import React from "react";

import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { useUserContext, useUserContextSetters } from "contexts/UserContext";

const FRAME_DATA = {
  imgSrc: "/static/img/solutions/simulator-panel.png",
  imgAlt: "Um painel solar com uma avaliação positiva",
  title: "Simulador Enermatch",
  buttonText: "Simular para outro imóvel",
};
const OFFER_SELECTION_PAGE = "/solutions/simulator-results";

export const Simulator = ({ history }) => {
  const { currentSpace, automationSpaces } = useUserContext();
  const { setCurrentSpace } = useUserContextSetters();

  const handleNavigation = (choice: "new" | "existing") => {
    history.push(OFFER_SELECTION_PAGE, { newSpace: choice === "new" });
  };

  const handleSpaceChange = (event, space) => {
    setCurrentSpace(space);
  };

  return (
    <SolutionsFrame
      {...FRAME_DATA}
      onButtonClick={() => handleNavigation("new")}
    >
      <BlockStandard hideDivider>
        <Typography variant="h2">Muito bom!</Typography>
        <Typography variant="h3" fontWeight="normal">
          Escolha o imóvel para o qual deseja simular a economia e redução da
          pegada carbônica energética potenciais.
        </Typography>

        <BlockStandard hideDivider>
          <Grid item container direction="row">
            <Autocomplete
              value={currentSpace}
              /* @ts-ignore-next-line autocomplete's value can teoretically be null */
              onChange={handleSpaceChange}
              sx={{ flex: 1 }}
              options={automationSpaces}
              renderInput={(params) => <TextField {...params} label="Imóvel" />}
              getOptionLabel={({ brand, schoolName }) =>
                `${brand} | ${schoolName}`
              }
            />
            <Button
              sx={{ ml: 2 }}
              variant="contained"
              onClick={() => handleNavigation("existing")}
            >
              Continuar
            </Button>
          </Grid>
        </BlockStandard>
      </BlockStandard>

      <BlockStandard hideDivider>
        <Grid
          container
          item
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <Divider sx={{ width: "100%" }} variant="fullWidth">
            <Typography sx={{ mx: 2 }}> OU </Typography>
          </Divider>
        </Grid>
      </BlockStandard>
    </SolutionsFrame>
  );
};
